import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-light-bulb-icon',
  standalone: true,
  templateUrl: './light-bulb-icon.component.html',
  styleUrls: ['./light-bulb-icon.component.scss']
})
export class LightBulbIconComponent {
  @Input() width: number | string = 17;
  @Input() height: number | string = 17;
}
